import Message from 'semantic-ui-react/dist/es/collections/Message';
import './Message.css';

export default Message;
